<template>
  <ul class="br-admin-notes__list">
    <li v-for="note in notes" :key="note.adminNoteId" class="br-admin-notes__item">
      <div class="br-admin-notes__avatar br-admin-notes__avatar--sm" aria-hidden="true">
        {{ noteInitial(note) }}
      </div>

      <div class="br-admin-notes__item-content">
        <div class="br-admin-notes__item-head">
          <span class="br-admin-notes__user">{{ note.createUser || '—' }}</span>
          <span class="br-admin-notes__time">{{ formatTime(note.createTime) }}</span>
        </div>

        <div class="br-admin-notes__body">{{ note.remark }}</div>

        <ul v-if="note.attachments && note.attachments.length" class="br-admin-notes__files">
          <li
            v-for="file in note.attachments"
            :key="file.attachmentId"
            class="br-admin-notes__file-item"
          >
            <a
              class="br-admin-notes__file-card"
              href="#"
              role="button"
              :title="file.originalFileName || file.fileName"
              @click.prevent="$emit('preview', file)"
            >
              <span class="br-admin-notes__file-thumb" aria-hidden="true">
                <img
                  v-if="isImageAttachment(file)"
                  class="br-admin-notes__file-thumb-img"
                  :src="file.fileUrl"
                  alt=""
                >
                <span
                  v-else
                  class="br-admin-notes__file-thumb-ext"
                >{{ attachmentExtLabel(file) }}</span>
              </span>
              <span class="br-admin-notes__file-name">
                {{ file.originalFileName || file.fileName }}
              </span>
            </a>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</template>

<script>
import { formatMessageDateTime } from '@/_services/messageBoard.service';

export default {
  name: 'BrAdminNotesList',
  props: {
    notes: { type: Array, default: () => [] },
  },
  methods: {
    formatTime(value) {
      const full = formatMessageDateTime(value) || '';
      // Figma 展示为日期（YYYY-MM-DD）
      const m = full.match(/^(\d{4}-\d{2}-\d{2})/);
      return m ? m[1] : full;
    },
    noteInitial(note) {
      const name = String(note?.createUser || '').trim();
      return name ? name.charAt(0).toUpperCase() : 'A';
    },
    isImagePath(nameOrUrl) {
      return /\.(png|jpe?g|gif|bmp|svg|webp)($|\?)/i.test(String(nameOrUrl || ''));
    },
    isImageAttachment(file) {
      return this.isImagePath(file?.originalFileName)
        || this.isImagePath(file?.fileName)
        || this.isImagePath(file?.fileUrl);
    },
    attachmentExtLabel(file) {
      const name = String(file?.originalFileName || file?.fileName || file?.fileUrl || '');
      const m = name.match(/\.([a-z0-9]+)($|\?)/i);
      return m ? m[1].toUpperCase() : 'FILE';
    },
  },
};
</script>

<style scoped lang="scss">
@import '../styles/_br-admin-notes-list.scss';
</style>
